//store representing rates
import { defineStore } from 'pinia'
import { type Rate, rateSchema  } from '@/types/types'
import { useStoreSyncer } from '@/composables/Store-syncer';
import { computed } from 'vue';

export const useRatesStore = defineStore('rates', () => {
  const { fetchAll, update, remove, create, allItems, loading, error } = useStoreSyncer('/rates', 'rates'); 

  const jobRateOptions = [
  { value: 'rate1', name: '1. Residential Rate' },
  { value: 'rate2', name: '2. Commercial Rate' }
]

  const allRates = computed(()=>{
    //return cache.getFromCache('invoices') || [];
    return allItems.value;
  })

  const tableData = computed(()=>{
    //const data = cache.getFromCache('invoices') || [];
    return allItems.value;

  })

  /**
   * fetch all invoices from backend, store in cache
   *
   */
  async function fetchAllRates() {
    console.log('rates store fetching all from backend...')
    return await fetchAll();
  }

  /**
   * update a single invoice
   * @return Array<Invoice> the array of projectInvoices
   */
  async function updateRate(rate: Rate) {
    //const projectId = parseInt(inv.projectId);
    console.log('rates store.updateRate()...')
    return await update(rate,rateSchema,'rate');
  }

  /**
   * delete an invoice
   */
  async function deleteRate(id: Number) {
    console.log('rates store deleteRate for id : ' + id)
    return await remove(id);
  }

  /**
   * create a new invoice
   * backend will assign the invoiceId and return it
   */
  async function createRate(rate: Rate) {
    console.log('rates store createRate : ' + JSON.stringify(rate))
    return await create(rate, rateSchema, 'invoice');
  }


  return {
    fetchAllRates,
    updateRate,
    createRate,
    deleteRate,
    loading,
    tableData,
    allRates,
    jobRateOptions
  }
})
